import React, { memo } from "react";
import AerosNode from "./AerosNode";
import { i18n } from "../../../translate/i18n";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="removeTag" selected={selected} isConnectable={isConnectable}>
    {data?.tag?.name || i18n.t("aeros.flow.nodes.tagNotSelected")}
  </AerosNode>
));
